import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"input-panel\">\r\n    {{yield}}\r\n</div>",{ moduleName: "dac-error-budget/components/input-panel.hbs" })